module.exports = __webpack_public_path__ + "img/logo.f2e7550b.png";